import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=07dc3bf4&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=07dc3bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc3bf4",
  null
  
)

export default component.exports